<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-md-6">
            <div class="card">
                <div class="card-body">
                    <h4 class="mt-3" style="color: #7F3486; text-align: center; font-weight: bold">Please Register an Institution to proceed further</h4>
                    <div class="row my-5 d-flex justify-content-center">
                        <div class="col-md-6">
                            <div class="card pt-4 login-card">
                                <div class="row form-group">
                                    <h4 class="col-md-12" style="text-align: center; color: #7F3486; font-weight: bold" [routerLink]="'/School/create-School/add'">Click Here</h4>
                                </div>
                                <div class="row fit-image">
                                    <div class="card imghvr-reveal-up school-img" style="">
                                        <img src="assets/images/ristaschool/school-default.png" alt="" style="border-radius: 0" [routerLink]="'/School/create-School/add'">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>